// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import ExamRecordCard from './ExamRecordCard';
import ScrollToTop from './ResultScrollToTop';
import ExamReturnIcon from '../../../assets/images/exam-return-icon.svg';
import ImgPopUp from './ExamImgPopUp';
import ExamTopicRemarkActive from '../../../assets/images/exam-topic-remark-active-icon.svg';
import QuestionsAllCorrectIcon from '../../../assets/images/course-content-completed-pic.svg';
import * as Markdown from '../../../components/Markdown';

const S = {
  ExamScoreWrap: styled.div`
    background: #FFFFFF;
    padding: 0px 100px;
  `,
  Return: styled.div`
    background: #FFFFFF;
    margin: 37px 0;
  `,
  ReturnIcon: styled.img.attrs({ src: ExamReturnIcon })`
    cursor: pointer;
  `,
  WrongTopicArea: styled.div`
    border-radius: 14px;
    padding: 39px 55px;
    margin: 45px 0;
  `,
  WrongTopicTitle: styled.p`
    font-weight: 700;
    font-size: 36px;
    color: #5C5C5C;
    margin-bottom: 48px;
    border-bottom: 2px solid silver;
    padding-bottom: 5px;
  `,
  WrongTopic: styled.div`
    margin-bottom: 90px;
    font-weight: 700;
    color: #5C5C5C;
  `,
  WrongTopicNumber: styled.div`
    margin-right: 10px;
    background-color: #fff;
    border-radius: 0 20px 20px 0;
    position: absolute;
    left: -10px;
    padding: 0 10px 0 25px;
  `,
  WrongTopicContent: styled.div`
    margin-left: 24px;
  `,
  WrongTopicQuestion: styled.div`
    line-height: 40px;
    display: flex;
    background-color: #e6e6e6;
    border-radius: 15px;
    padding: 20px 55px 20px 20px;
    position: relative
  `,
  WrongTopicText: styled.div`
    margin-top: 5px;
    margin-left: 32px;
  `,
  CorrectAnswerList: styled.ul`
    list-style: disc;
  `,
  ChoosedAnswerList: styled.ul`
    color: #E98484;
    margin-top: 30px;
    list-style: disc;
  `,
  CorrectAnswer: styled.li`
    margin-left: 40px;
    font-size: 18px;
  `,
  ChoosedAnswer: styled.li`
    margin-left: 40px;
    font-size: 18px;
  `,
  Img: styled.img`
    display: flex;
    margin-top: 10px;
    &:hover {
      cursor: pointer;
    }
  `,
  AnswerTitle: styled.p`
    font-size: 18px;
    margin-bottom: 3px;
  `,
  RemarkActiveIcon: styled.img.attrs({ src: ExamTopicRemarkActive })``,
  Remark: styled.div`
    position: absolute;
    right: 18px;
    bottom: 10px;
  `,
  NoWrongQuestionText: styled.p`
    text-align: center;
    font-size: 22px;
    color: #666666;
    margin: 20px 0 50px;
  `,
  QuestionsAllCorrect: styled.img.attrs({ src: QuestionsAllCorrectIcon })`
    display: block;
    margin: 80px auto 0;
  `,
}

const ExamScore = (props: any): JSX.Element => {

  const hanleCloseResult = props.hanleCloseResult;
  const examResult = props.examResult;
  const examList = props.examList;
  const baseUrl = props.baseUrl;

  const examCorrectResult = examResult.answerList;
  const [wrongQuestions, setWrongQuestions] = useState(() => {
    examCorrectResult.forEach(function(item: any) {
      item.wrongAnswer = examList[item.title].answers;
      item.wrongQuestion = examList[item.title].contents;
      item.isRemark = examList[item.title].isRemark;
    });
    return examCorrectResult;
  })
  const [showImgUp, setShowImgUp] = useState(false);
  const [showImgUpImg, setShowImgUpImg] = useState('');
  const scoreList = {
    score: examResult.score,
    correctNumber: examResult.correctNumber,
    wrongNumber: examResult.wrongNumber,
    status: examResult.status
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ChoosedAnswer = (props: any) => {
    const wrongAnswer = props.wrongAnswer;
    return (
      <>
        { wrongAnswer.map((item: any, index: number) => {
          return (
            <S.ChoosedAnswer key={index}>
              <Markdown.ExamMarkdown markdown={item} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
            </S.ChoosedAnswer>
          )
        })}
      </>
    )
  }

  const CorrectAnswer = (props: any) => {
    const correctAnswer = props.correctAnswer;
    return (
      <>
        { correctAnswer.map((item: any, index: number) => {
          return (
            <S.CorrectAnswer key={index}>
              <Markdown.ExamMarkdown markdown={item} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
            </S.CorrectAnswer>
          )
        })}
      </>
    )
  }

  const WrongQuestionArea = (props: any) => {
    const topicContent = props.topicContent;

    return (
      <>
        <S.ChoosedAnswerList>
          <S.AnswerTitle>Choosed Answer :</S.AnswerTitle>
          { topicContent.wrongAnswer.length === 0 ? null : <ChoosedAnswer wrongAnswer={topicContent.choosedAnswer}/>}
        </S.ChoosedAnswerList>
        <S.CorrectAnswerList>
          <S.AnswerTitle>Correct Answer :</S.AnswerTitle>
          { topicContent.answers.length === 0 ? null : <CorrectAnswer correctAnswer={topicContent.answers}/>}
        </S.CorrectAnswerList>
      </>
    )
  }

  return (
    <S.ExamScoreWrap>
      <S.Return><S.ReturnIcon onClick={() => { hanleCloseResult() }} /></S.Return>
      <ExamRecordCard scoreList={scoreList}/>
      { wrongQuestions.length === 0 ? (
        examResult.correctNumber + examResult.wrongNumber === 0 ? (
          <>
            <S.QuestionsAllCorrect />
          </>
        ) : (
          <>
            <S.QuestionsAllCorrect />
            <S.NoWrongQuestionText>
              Congratulations!<br/>
              All multiple select questions are correct!
            </S.NoWrongQuestionText>
          </>
        )
      ) : (
        <S.WrongTopicArea>
          <S.WrongTopicTitle>Wrong Question</S.WrongTopicTitle>
          { wrongQuestions.map((item: any, index: number) => {
            return (
              <S.WrongTopic key={index}>
                <S.WrongTopicQuestion>
                  <S.WrongTopicNumber><p>{parseInt(item.title)+1}.</p></S.WrongTopicNumber>
                  <S.WrongTopicText>
                    <Markdown.ExamMarkdown markdown={item.question} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
                  </S.WrongTopicText>
                  <S.Remark>
                    { item.isRemark ? <S.RemarkActiveIcon/> : null }
                  </S.Remark>
                </S.WrongTopicQuestion>
                <S.WrongTopicContent>
                  <WrongQuestionArea topicContent = {item}/>
                </S.WrongTopicContent>
              </S.WrongTopic>
            )
          })}
        </S.WrongTopicArea>
      )}
      <ScrollToTop></ScrollToTop>
      <ImgPopUp img={showImgUpImg} showImgUp={showImgUp} setShowImgUp={setShowImgUp} />
    </S.ExamScoreWrap>
  )
}

export { ExamScore as default };
